import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import { getStoreImageUrl } from 'lib/image';
import { toStoreCouponsLink } from 'lib/links';

const toTotalActiveCouponsText = (couponQuantity) => {
  switch (couponQuantity) {
    case 0:
      return 'Sem cupons';
    case 1:
      return '1 cupom';
    default:
      return `${couponQuantity} cupons`;
  }
};

const onStoreClick = (storeName, gaEventCategory) => {
  sendEvent({
    action: 'go_store_highlight',
    category: gaEventCategory,
    data: storeName,
  });
};

const CouponsStoreItem = ({
  gaEventCategory,
  storeName,
  storeImage,
  storeSlug,
  totalCoupons,
}) => (
  <NextLink href={toStoreCouponsLink(storeSlug)} prefetch={false} passHref>
    <Box
      as="a"
      className="w-full flex-col items-center justify-center gap-2 rounded-4 border-2 border-neutral-high-200 p-3 transition hover:shadow-md dark:border-neutral-low-200 lg:gap-0 lg:px-12 lg:py-8"
      onClick={() => {
        onStoreClick(storeName, gaEventCategory);
      }}
    >
      <Image
        alt={`Imagem da loja ${storeName}`}
        className="mb-2 rounded-full border border-neutral-high-300 object-contain md:h-full md:w-20"
        height={64}
        loading={null}
        sizes="40px"
        src={getStoreImageUrl(storeImage, 40)}
        srcSet={`
          ${getStoreImageUrl(storeImage, 60)} 60w,
          ${getStoreImageUrl(storeImage, 80)} 80w,
          ${getStoreImageUrl(storeImage, 120)} 120w,
        `}
        width={64}
        priority
      />
      <span className="flex flex-col items-center text-ellipsis">
        <Text className="whitespace-nowrap lg:text-center" size="size1" bold>
          {storeName}
        </Text>
        <Text className="hidden whitespace-nowrap" size="size1" bold>
          {toTotalActiveCouponsText(totalCoupons)}
        </Text>
      </span>
    </Box>
  </NextLink>
);

CouponsStoreItem.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  storeImage: PropTypes.string.isRequired,
  storeSlug: PropTypes.string.isRequired,
  totalCoupons: PropTypes.number.isRequired,
};

export default CouponsStoreItem;
